import { Component } from '@angular/core';
import * as Highcharts from 'highcharts';
import { MatDialogRef } from '@angular/material/dialog';
import { FacultyService } from '../faculty.service';
import moment from 'moment';

@Component({
  selector: 'app-facultytrackingnewdialog',
  templateUrl: './facultytrackingnewdialog.component.html',
  styleUrls: ['./facultytrackingnewdialog.component.scss']
})
export class FacultytrackingnewdialogComponent {

  campusTypeData: any[] = [];

  constructor(private http: FacultyService, private ref: MatDialogRef<FacultytrackingnewdialogComponent>) { }
  selectedDate = new Date();
  customDate: any;

  ngOnInit(): void {
    this.customDate = moment(this.selectedDate).format("DD-MM-YYYY");
    this.http.getCampusTypeData(this.customDate).subscribe({
      next: (res: any) => {
        this.campusTypeData = res
        this.pieChart(res)
      },
      error: (err: any) => {
        console.log(err)
      }
    })
  }


  pieChart(res: any) {

    const chartData = res
      .map((item: any) => ({
        name: item.los,
        y: item.total,
        color: this.getStatusColor(item.los)
      }));

    const chartOptions: Highcharts.Options = {
      chart: {
        type: 'pie',
        backgroundColor: 'transparent',
        height: '250px'
      },
      title: {
        text: '',
      },
      tooltip: {
        pointFormat: '{series.name}: <b>{point.percentage:.0f}%</b>',
      },
      plotOptions: {
        pie: {
          innerSize: '70%',
          dataLabels: {
            enabled: true,
            format: '{point.percentage:.0f}%',
            distance: 20,
            style: {
              color: '#000',
              fontWeight: 'bold',
            }
          },
          showInLegend: true,
        }
      },
      credits: {
        enabled: false
      },
      legend: {
        enabled: false
      },
      series: [{
        type: 'pie',
        name: 'Tickets',
        data: chartData
      }]
    };

    // Then create the chart:
    Highcharts.chart('pieChart', chartOptions);
  }

  getStatusColor(status: string): string {
    console.log(status)
    switch (status.toUpperCase()) {
      case 'DS AND RES': return '#1E88E5';
      case 'DAYSCHOLAR': return '#43A047';
      case 'RESIDENTIAL': return '#FB8C00';
      default: return '#9E9E9E'; // fallback grey
    }
  }

  close() {
    this.ref.close()
  }

}
